<template>
  <div>
    <!-- Header row -->
    <v-row>
      <v-col class="text-center">نام</v-col>
      <v-col class="text-center">آخرین وضعیت</v-col>
      <v-col class="text-center">زمان آخرین وضعیت</v-col>
      <v-col class="text-center">آخرین دستور</v-col>
    </v-row>

    <!-- Devices rows -->
    <v-row v-for="device in relays" :key="device.id">
      <v-col cols="12" class="row mx-auto text-center device-row">

        <!-- NAME -->
        <v-col class="text-center">
          <v-chip>
            <strong>{{ device.name }}</strong>
          </v-chip>
        </v-col>

        <!-- LAST STATE (data._value) -->
        <v-col class="text-center">
          <v-chip :color="device.data && device.data._value ? 'success' : 'red'">
            {{ device.data && device.data._value ? 'روشن' : 'خاموش' }}
          </v-chip>
        </v-col>

        <!-- LAST TIME -->
        <v-col class="text-center">
          <template v-if="device.data?._time || device.set?._time">
            <v-tooltip top color="red">
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on">
                  {{ formatTime(device.data?._time || device.set?._time) }}
                </v-chip>
              </template>
              <span>
                {{ formatDate(device.data?._time || device.set?._time) }}
              </span>
            </v-tooltip>
          </template>

          <v-chip v-else color="warning">
            از این رله اطلاعاتی موجود نیست
          </v-chip>
        </v-col>

        <!-- SWITCH (last command / set._value) -->
        <v-col class="d-flex justify-center">
          <!-- 
            Vuetify 2: use "input-value" as controlled value
            and @change for change events 
          -->
          <v-switch
            class="my-auto"
            :disabled="updateLoading"
            :input-value="device.set && device.set._value"
            @change="onSwitchChange($event, device)"
            hide-details
            inset
          />

          <v-chip :color="device.set && device.set._value ? 'success' : 'red'">
            {{ device.set && device.set._value ? 'فعال' : 'غیر فعال' }}
          </v-chip>
        </v-col>

      </v-col>

      <v-col cols="12">
        <v-divider class="mx-10"></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DeviceTable',

  props: {
    updateLoading: {
      type: Boolean,
      default: false
    },
    relays: {
      type: Array,
      required: true
    },
    // "loading" prop was unused; you can remove it in parent too if not needed
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * Handle v-switch change.
     *
     * Vuetify 2 passes the new boolean value as first param.
     * We update device.set._value locally for instant UI feedback,
     * then emit "confirmStatus" so parent can send command / update backend.
     */
    onSwitchChange(newValue, device) {
      // Local update (for UI responsiveness)
      if (device.set) {
        device.set._value = newValue;
      } else {
        // if for some reason set is missing, safeguard
        device.set = { _value: newValue };
      }

      // Emit to parent (you can adjust payload if you want more info)
      this.$emit('confirmStatus', device);
    },

    // Format time portion (HH:mm:ss) with Persian locale
    formatTime(timestamp) {
      if (!timestamp) return '-';
      return new Date(timestamp).toLocaleTimeString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    // Format date portion (YYYY/MM/DD) with Persian locale
    formatDate(timestamp) {
      if (!timestamp) return '-';
      return new Date(timestamp).toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.device-row:hover {
  background: rgba(0, 0, 0, 0.05);
}
</style>

